import React from "react";
import { Link } from "react-router-dom";
import { GiSpeedBoat } from "react-icons/gi";
import { BsTelephoneFill } from "react-icons/bs";
import { FaWater, FaStar, FaShieldAlt, FaFlag } from "react-icons/fa";
// import Banner from "../components/common/Banner";
import NavFilters from "../components/common/NavFilters";
// import HomeBanner from "../banners/banner.jpg";
// import HomeBanner from "../banners/waterbanner.jpg";
import { motion } from "framer-motion";
import SEO from "../components/common/SEO";
import {
  getLocalBusinessSchema,
  getWebsiteSchema,
  getFAQSchema,
} from "../utils/structuredData";
import { tourPackages } from "../data/dummyData";
// import { speedBoatData } from "../data/dummyData";

import {
  // BestPlaces,
  Explore,
  // FeaturedDestinations,
  // TopTours,
  TravelPassion,
  FeaturedPackages,
} from "../components/home";
import Reviews from "../components/home/Reviews";

const HomeBanner = `${process.env.PUBLIC_URL}/bannerhome.jpg`;

const Home = () => {
  // Import Framer Motion for animations
  const structuredData = [
    getLocalBusinessSchema(),
    getWebsiteSchema(),
    getFAQSchema(),
  ];

  // Prepare featured packages: 3 from quicksilver + 1 from jet-ski
  const quicksilverTour = tourPackages.find(
    (tour) => tour.slug === "quicksilver-tour",
  );
  const jetSkiTour = tourPackages.find(
    (tour) => tour.slug === "jet-ski-adventure",
  );
  const bayLinerTour = tourPackages.find(
    (tour) => tour.slug === "bayliner-water-sports",
  );

  const featuredPackages = [
    // 1. Secret Beach Escape (unique tour)
    {
      id: "secret-beach-escape",
      name: "Secret Beach Escape",
      description:
        "A premium experience to hidden beaches, perfect for relaxing, swimming, and enjoying untouched nature along the stunning Albanian Riviera.",
      image: `${process.env.PUBLIC_URL}/images/speedboat/secretbeach (7).jpeg`,
      price_per_person: "100",
      priceLabel: "per person",
      duration: "4 hours",
      tourName: "Unique Tour",
      badge: "Premium Tour",
      included: [
        "Private skipper",
        "Life jackets",
        "Fuel",
        "Scenic coastal route",
        "Swimming stops at hidden beaches",
      ],
      isRequestOnly: true,
      linkTo: "/unique-tours",
    },
    // 2. Express Sea Tour first, then Shipwreck (Coastal temporarily disabled)
    ...[3, 1]
      .map((pkgId) =>
        (quicksilverTour?.packages || []).find((p) => p.id === pkgId),
      )
      .filter(Boolean)
      .map((pkg) => ({
        ...pkg,
        tourSlug: quicksilverTour.slug,
        tourName: "Boat Tour",
      })),
    // First package from Jet Ski Adventure
    ...(jetSkiTour?.packages || []).slice(0, 1).map((pkg) => ({
      ...pkg,
      tourSlug: jetSkiTour.slug,
      tourName: "Jet Ski",
      image: pkg.image || jetSkiTour.image,
    })),
    // First package only from Bayliner (Water Sports Session) — hidden temporarily
    // ...(bayLinerTour?.packages || []).slice(0, 1).map((pkg) => ({
    //   ...pkg,
    //   tourSlug: bayLinerTour.slug,
    //   tourName: "Water Sports",
    //   image: pkg.image || bayLinerTour.image,
    // })),
    // Relaxing Private Tour (request-only)
    {
      id: "relaxing-private-tour",
      name: "Relaxing Private Tour",
      description:
        "Enjoy a peaceful private cruise along the Albanian Riviera. Perfect for couples and small groups. Bottle of prosecco included.",
      image: `${process.env.PUBLIC_URL}/images/speedboat/quicksilver6.jpeg`,
      price_per_person: "350",
      priceLabel: "1\u20133 persons",
      duration: "90 minutes",
      tourName: "Unique Tour",
      badge: "Private Tour",
      included: [
        "Private skipper",
        "Life jackets",
        "Fuel",
        "Scenic coastal route",
        "Bottle of Prosecco",
      ],
      isRequestOnly: true,
      linkTo: "/unique-tours",
    },
  ];

  return (
    <>
      <SEO
        title="Boat Tours Durrës Albania | Speedboat, Yacht & Jet Ski – SeaPulse"
        description="Book the best boat tours in Durrës, Albania from €50/person. Speedboat adventures, WWII shipwreck dives, secret beach escapes, luxury yacht charters & jet ski rentals. Professional crew, modern fleet, instant online booking."
        keywords="boat tours Durrës, boat tours Albania, speedboat Durrës, sea tour Albania, Durrës boat excursion, Albanian Riviera boat tour, WWII shipwreck tour Albania, secret beach escape Albania, hidden beach boat tour, Adriatic boat tour, yacht rental Durrës, jet ski Durrës, water sports Albania, Durrës marina tours, boat trip Albania, coastal tour Albania, sea activities Durrës, book boat tour Albania, best boat tours Albania, SeaPulse Albania"
        canonical="/"
        structuredData={structuredData}
      />
      <div className="relative w-full min-h-[550px] h-[80vh] md:h-[90vh] max-h-[900px] flex items-center justify-center overflow-hidden pt-20 pb-4 md:pt-0 md:pb-0">
        {/* Animated background overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 via-cyan-500/20 to-blue-800/20 animate-gradient-shift z-5"></div>

        {/* Static banner image - shown on all screens */}
        <img
          src={HomeBanner}
          alt="Boat Adventures in Durrës"
          className="absolute inset-0 w-full h-full object-cover object-center brightness-75 transition-all duration-500 scale-105"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 via-cyan-800/50 to-blue-600/30 pointer-events-none z-10" />

        <div className="relative z-20 flex flex-col items-center justify-center text-center px-4 py-4 w-full max-w-6xl mx-auto">
          <span
            className="text-[10px] sm:text-xs md:text-base lg:text-lg font-extrabold tracking-wider md:tracking-widest mb-2 md:mb-4 animate-fadeInDown uppercase bg-gradient-to-r from-cyan-300 via-blue-200 to-cyan-300 bg-clip-text text-transparent drop-shadow-2xl"
            style={{
              fontFamily:
                "'Inter', 'Montserrat', 'Segoe UI', Arial, sans-serif",
              letterSpacing: "0.15em",
              fontWeight: 700,
            }}
          >
            <span className="hidden sm:inline-flex items-center gap-1">
              <FaWater className="text-cyan-300" />{" "}
            </span>
            BOAT ADVENTURES IN DURRES, ALBANIA
            <span className="hidden sm:inline-flex items-center gap-1">
              {" "}
              <FaWater className="text-cyan-300" />
            </span>
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white drop-shadow-2xl mb-3 md:mb-6 animate-fadeInDown leading-tight">
            Dive Into{" "}
            <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
              Albanian
            </span>{" "}
            Waters
          </h1>
          <p className="text-xs sm:text-sm md:text-lg lg:text-xl text-white/95 mb-5 md:mb-8 max-w-lg md:max-w-2xl lg:max-w-3xl animate-fadeInUp drop-shadow-lg leading-relaxed px-2">
            Experience the stunning Adriatic coastline, crystal-clear waters,
            and thrilling boat adventures in Durres.
          </p>
          <div className="flex flex-col sm:flex-row gap-2.5 md:gap-4 w-full sm:w-auto px-4 sm:px-0 animate-fadeInUp max-w-md sm:max-w-none">
            <Link
              to="/boat-tours"
              className="group relative bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold py-2.5 md:py-4 px-5 md:px-8 rounded-full shadow-2xl shadow-cyan-500/50 hover:shadow-cyan-400/70 transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 border-2 border-white/30 text-xs sm:text-sm md:text-base"
            >
              <span className="relative z-10 flex items-center justify-center gap-2">
                <GiSpeedBoat className="text-lg md:text-xl" /> Book Your Boat
              </span>
            </Link>
            <Link
              to="/contact"
              className="bg-white/90 backdrop-blur-sm hover:bg-white text-blue-700 font-bold py-2.5 md:py-4 px-5 md:px-8 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 border-2 border-cyan-400/50 text-xs sm:text-sm md:text-base flex items-center justify-center gap-2"
            >
              <BsTelephoneFill className="text-sm md:text-base" /> Contact Us
            </Link>
          </div>

          {/* Trust badges - Professional Layout */}
          <div className="mt-5 md:mt-8 animate-fadeInUp w-full max-w-2xl px-4">
            <div className="grid grid-cols-3 gap-2 sm:gap-3 md:gap-4">
              <div className="flex flex-col items-center gap-1.5 md:gap-2 bg-white/15 backdrop-blur-md px-2 sm:px-3 md:px-4 py-2 md:py-3 rounded-xl border border-white/30 hover:bg-white/25 transition-all duration-300">
                <FaStar className="text-yellow-400 text-base sm:text-lg md:text-xl" />
                <span className="font-bold text-[10px] sm:text-xs md:text-sm text-white text-center leading-tight">
                  5-Star
                  <br className="sm:hidden" /> Rated
                </span>
              </div>
              <div className="flex flex-col items-center gap-1.5 md:gap-2 bg-white/15 backdrop-blur-md px-2 sm:px-3 md:px-4 py-2 md:py-3 rounded-xl border border-white/30 hover:bg-white/25 transition-all duration-300">
                <FaShieldAlt className="text-cyan-300 text-base sm:text-lg md:text-xl" />
                <span className="font-bold text-[10px] sm:text-xs md:text-sm text-white text-center leading-tight">
                  Fully
                  <br className="sm:hidden" /> Licensed
                </span>
              </div>
              <div className="flex flex-col items-center gap-1.5 md:gap-2 bg-white/15 backdrop-blur-md px-2 sm:px-3 md:px-4 py-2 md:py-3 rounded-xl border border-white/30 hover:bg-white/25 transition-all duration-300">
                <FaFlag className="text-red-400 text-base sm:text-lg md:text-xl" />
                <span className="font-bold text-[10px] sm:text-xs md:text-sm text-white text-center leading-tight">
                  Local
                  <br className="sm:hidden" /> Experts
                </span>
              </div>
            </div>
          </div>

          <div className="mt-3 md:mt-6">
            <span
              className="text-sm sm:text-base md:text-xl lg:text-2xl font-extrabold tracking-wider md:tracking-widest animate-pulse uppercase bg-gradient-to-r from-cyan-200 via-white to-cyan-200 bg-clip-text text-transparent drop-shadow-2xl"
              style={{
                fontFamily:
                  "'Inter', 'Montserrat', 'Segoe UI', Arial, sans-serif",
                letterSpacing: "0.15em",
                fontWeight: 700,
              }}
            >
              SeaPulse Albania
            </span>
          </div>
        </div>
      </div>
      <NavFilters url="/hotels/search" />

      {/* Featured Tours - Full Width */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <Explore />
      </motion.div>

      {/* Featured Packages Section */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15 }}
        viewport={{ once: true }}
      >
        <FeaturedPackages packages={featuredPackages} />
      </motion.div>

      {/* Orikum Vlora Yachts Section */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="bg-gradient-to-b from-white to-blue-50 dark:from-gray-900 dark:to-gray-800 py-16 md:py-24 px-4 sm:px-6 lg:px-8"
      >
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-block bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-sm font-semibold px-5 py-2 rounded-full mb-4">
              Orikum · Vlorë
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent mb-4">
              Orikum Vlora Yachts
            </h2>
            <p className="text-base sm:text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto leading-relaxed">
              Luxury yachts cruising the stunning waters of Orikum &amp; Vlorë
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            {[
              `${process.env.PUBLIC_URL}/images/yachtsOrikum/01386cdf-1207-460f-bb5d-ec15952cb616.jpeg`,
              `${process.env.PUBLIC_URL}/images/yachtsOrikum/0902c8b7-9013-4047-a308-ccecfa3dd365.jpeg`,
              `${process.env.PUBLIC_URL}/images/yachtsOrikum/34ea85c5-16d2-4634-b234-4fc7c0a2c7a9.jpeg`,
              `${process.env.PUBLIC_URL}/images/yachtsOrikum/415d729a-dd89-456e-aba7-a96efe5360b1.jpeg`,
            ].map((src, i) => (
              <div
                key={i}
                className="overflow-hidden rounded-2xl aspect-[16/9] sm:aspect-[4/3] shadow-md"
              >
                <img
                  src={src}
                  alt={`Orikum Vlora Yacht ${i + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            ))}
          </div>
        </div>
      </motion.div>

      {/* Trending Guides */}
      {/* <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <TrendingGuides />
        </motion.div> */}

      {/* Reviews */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        viewport={{ once: true }}
      >
        <Reviews />
      </motion.div>

      {/* Travel Passion */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        viewport={{ once: true }}
      >
        <TravelPassion />
      </motion.div>
    </>
  );
};

export default Home;
